<div
  class="search-by-account-manager-component"
  data-automation-e2e-selector="searchAccountManager"
>
  <muni-search-input
    [dataSource]="accountManagerList"
    [groupField]="'type'"
    [valueField]="'name'"
    [groupHeaderTemplate]="customGroupHeaderTemplate"
    placeholder="Managers/Accounts"
    (selectEvent)="suggesterOnSelect($event)"
  >
  </muni-search-input>

  <ng-template #customGroupHeaderTemplate let-model="item">
    <span class="suggester-header"
      >{{ model.item.value + 's' | lowercase }}</span
    >
  </ng-template>
</div>
